/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Rule_Notetaker_DescInputs */



/**
* | output |
* | --- |
* | "Wundo joins the meeting and takes notes" |
*
* @param {Meetings_Exception_Rule_Notetaker_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_rule_notetaker_desc = /** @type {((inputs?: Meetings_Exception_Rule_Notetaker_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Rule_Notetaker_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo neemt deel aan de meeting en maakt notities")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rejoint la réunion et prend des notes")
	return /** @type {LocalizedString} */ ("Wundo joins the meeting and takes notes")
});